<template>
  <BaseModal>
    <template v-slot:modalheader>
      <p class="title is-4">
        {{ $t("contact.title") }}
      </p>
    </template>
    <template v-slot:modalbody>
      <p>
        {{ $t("contact.description") }}
      </p>
      <p>
        {{ $t("contact.description_2") }}
      </p>

      <a v-if="$i18n.locale == 'fr'" href="mailto:ouverts@perle-bizpal.ca">
        {{ $t("contact.email") }}</a
      >
      <a v-if="$i18n.locale == 'en'" href="mailto:open@bizpal-perle.ca">
        {{ $t("contact.email") }}</a
      >
    </template>
    <template v-slot:modalfooter>
      <b-button
        outlined
        type="is-primary"
        :aria-label="$t('message.close_btn')"
        @click="$parent.close()"
      >
        {{ $t("message.close_btn") }}
        <!--<font-awesome-icon :icon="['fas', 'times']" />-->
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/base-components/BaseModal.vue";
export default {
  name: "ContactModal",
  components: {
    BaseModal
  }
};
</script>

<style></style>
